import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import asyncAction from 'modules/core/lib/asyncAction'

import questionConfigs from 'modules/surveys/store/collections/questionConfigs'

function useQuestionConfig(questionConfigId: string, formId: string) {
  const [questionConfig, setQuestionConfig] = React.useState(
    questionConfigs.find({
      id: questionConfigId,
    })
  )

  const { loading } = useAsyncData(async () => {
    if (questionConfig) return

    await questionConfigs.fetch({
      data: {
        id: questionConfigId,
        surveys_form_id: formId,
      },
    })
    setQuestionConfig(
      questionConfigs.find({
        id: questionConfigId,
      })
    )
  }, [questionConfigId])

  return {
    loading,
    questionConfig,
  }
}

interface Props {
  description: string
  formId: string
  questionConfigId: string
  submit: string
  title: string
  onClose: () => void
}

function ArchiveQuestionConfigModal({
  description,
  formId,
  questionConfigId,
  submit: submitLabel,
  title,
  onClose,
}: Props) {
  const [running, setRunning] = React.useState(false)
  const { loading, questionConfig } = useQuestionConfig(questionConfigId, formId)

  const submit = async (closePortal: ClosePortalFn) => {
    if (!questionConfig) return

    setRunning(true)

    const { success } = await asyncAction(() =>
      questionConfig.rpc('toggle_archive', {
        archived: !questionConfig.attributes.archived,
        surveys_form_id: formId,
      })
    )
    setRunning(false)

    if (success) {
      questionConfigs.fetch({
        data: {
          surveys_form_id: formId,
        },
      })
      closePortal()
    }
  }

  return (
    <Modal
      title={title}
      description={description}
      illustration="surveys"
      onClose={onClose}
      onSubmit={submit}
      footer={
        <Button disabled={loading || running} submit>
          {submitLabel}
        </Button>
      }
    />
  )
}

export default observer(ArchiveQuestionConfigModal)
